import React, { useMemo } from "react";

import { useProfile } from "app/context";
import { t } from "app/utils";

import ListItem from "components/filters/ListItem";

export const itemTypes = {
  story_created: {
    label: t("Stories")
  },
  event_created: {
    label: t("Events"),
    predicate: ({ eventsEnabled }) => eventsEnabled
  },
  recognition_created: {
    label: t("Recognitions"),
    predicate: ({ recognitionsEnabled }) => recognitionsEnabled
  },
  photo_created: {
    label: t("Photos"),
    predicate: ({ eventsEnabled }) => eventsEnabled
  },
  widget_survey_activated: {
    label: t("Surveys"),
    predicate: ({ surveysEnabled }) => surveysEnabled
  },
  post_created: {
    label: t("Posts"),
    predicate: ({ postsEnabled }) => postsEnabled
  },
  user_claimed: {
    label: t("New Users")
  },
  announcement_created: {
    label: t("Featured Content")
  },
  social_share: {
    label: t("Social Shares")
  }
};

const getItemTypes = ({ organization }) => (
  Object.keys(itemTypes).filter(itemType => {
    const { predicate } = itemTypes[itemType];

    return !predicate || predicate(organization);
  })
);

const FeedItemTypeFilter = ({ onFilterClear, onTypeToggle, types }) => {
  const { profile } = useProfile();
  const itemTypeKeys = useMemo(() => getItemTypes(profile), [profile]);

  return (
    <ul>
      <ListItem
        label={t("All Types")}
        onClick={onFilterClear}
        active={!types}
      />
      {itemTypeKeys.map(type => (
        <ListItem
          key={type}
          label={itemTypes[type].label}
          onClick={() => onTypeToggle(type)}
          active={types && types.includes(type)}
        />
      ))}
    </ul>
  );
};

export default FeedItemTypeFilter;
